import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";
import { Navigate } from "react-router";

import type { CrmDataProvider } from "@/components/atomic-crm/providers/types";
import { LoginSkeleton } from "@/components/atomic-crm/login/LoginSkeleton";
import { PaginaLogin } from "./PaginaLogin";
import { RegistroInicial } from "./RegistroInicial";

/**
 * Página de entrada (copia adaptada de login/StartPage.tsx de Atomic).
 * Si todavía no existe ningún usuario (vista init_state), lleva al alta del primer
 * administrador; si no, muestra el login.
 */
export const PaginaInicio = () => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const {
    data: inicializado,
    error,
    isPending,
  } = useQuery({
    queryKey: ["init"],
    queryFn: async () => dataProvider.isInitialized(),
  });

  if (isPending) return <LoginSkeleton />;
  if (error) return <PaginaLogin />;
  if (inicializado) return <PaginaLogin />;

  return <Navigate to={RegistroInicial.path} />;
};
